import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2327">
      <div className="dark" data-id="element-2328">
        <Hero data-id="element-2329" />
      </div>
      <WhyUs data-id="element-2330" />
      <ByTheNumbers data-id="element-2331" />
      <Services data-id="element-2332" />
      <HowItWorks data-id="element-2333" />
      <FAQ data-id="element-2334" />
      <Reviews data-id="element-2335" />
      <CtaBanner data-id="element-2336" />
    </main>;
}